import './index.css';
import './timer.css';

import { CountdownFormClient } from './client';

export const CountdownForm = ({ ...props }) => {
  return <CountdownFormClient {...props} />;
};
